import { render, staticRenderFns } from "./FormPassEdit.vue?vue&type=template&id=d38c482a&scoped=true&"
import script from "./FormPassEdit.vue?vue&type=script&lang=ts&"
export * from "./FormPassEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d38c482a",
  null
  
)

export default component.exports